import { apiGet, GetTeamsRequest, GetTeamsResponse } from 'api';

export const getTeams = (request?: GetTeamsRequest): Promise<GetTeamsResponse> => {
  return apiGet<GetTeamsResponse, GetTeamsRequest>('admin/teams', request);
};
